export default {
  title: "按使用付費",
  subtitle: "按需購買點數，無需訂閱",
  calculation_title: "碳排放計算",
  report_title: "報告",
  combo_title: "組合套裝",
  combo_subtitle: "透過我們的組合套裝節省更多",
  select_quantity: "選擇數量",
  select_package: "選擇套裝",
  total: "總計",
  calculation_credits: "計算點數",
  report_credits: "報告點數",
  credits: "點數",
  price: "價格",
  buy_now: "立即購買",
  starter_pack: "入門套裝",
  professional_pack: "專業套裝",
  enterprise_pack: "企業套裝",
  save_x_percent: "節省 {percent}%",
  note: "您購買的點數永不過期。",
  expiry_note: "您可以隨時使用。未來將提供可選的點數延期或轉換功能。",
  calculation_price: "碳排放計算",
  report_price: "報告",
  calculation_price_dynamic: "{price} 每次計算",
  report_price_dynamic: "{price} 每份報告",
  benefits: "按使用付費的優勢",
  future_features: "未來功能",
  future_features_desc: "我們計劃在未來推出可選的點數延期和兌換功能。目前無需任何操作。",
  extension_option_future: "點數延期",
  extension_option_future_desc: "以低費用延長點數的有效期（未來版本提供）。",
  credit_exchange_future: "點數兌換",
  credit_exchange_future_desc: "將未使用或過期的點數兌換為未來版本的試用訪問權限。",
  quantity: "數量",
  ladder_pricing: "階梯定價",
  unit: "單位",
  pay_per_use_benefit1: "無需訂閱",
  pay_per_use_benefit2: "只為使用的部分付費",
  pay_per_use_benefit3: "永久有效",
};
